export const environment = {
    apiUrl: 'https://back-dev.good-circle.com',
    calendlyUrl: null,
};
